import IntervalController from "./interval_controller"

// Este es un intervalo de loop. Se repite X veces un cycle de Y segundos.
export default class extends IntervalController {

  static targets = [
    "fullCycles"
  ]
  static values = {
  }

  initClicks(){
    super.initClicks()
    this._cycleClick = 0
    this._currentCycle = 0
  }

  incClick() {
    super.incClick();
    this._cycleClick = Math.floor(this.currentClick % this._cycleDuration)
    this._currentCycle = Math.floor(this.currentClick / this._cycleDuration)
  }

  renderElapsedTime() {
    super.renderElapsedTime();
    this.timerPlayerOutlet.clickMessageTarget.innerText = `${this._currentCycle+1}/${this.fullCyclesTarget.value}`
  }

  initDurations() {
    this._cycleDuration = parseInt(this.durationMinutesTarget.value) * 60 + parseInt(this.durationSecondsTarget.value)
    this._totalDuration = this._cycleDuration * parseInt(this.fullCyclesTarget.value)
    document.dispatchEvent(new CustomEvent("interval:durationChanged"))
  }

  presentation() {
    return {...super.presentation(), type: "loop", elapsed: this._cycleClick + 1,
      duration: this._cycleDuration, cycle: this._currentCycle + 1, cycles: Number(this.fullCyclesTarget.value)}
  }

  isFirstClickOfCycle(){
    return this._cycleClick === 0
  }

  isLastClickOfCycle(){
    return this._cycleClick === this._cycleDuration - 1
  }

  isFirstCycle(){
    return this._currentCycle === 0
  }

  isLastCycle(){
    return this._currentCycle === parseInt(this.fullCyclesTarget.value) - 1
  }

  hasNextAction() {
    return !this.isLastCycle()
  }

  playNeededAudio(){
    if (this.isOverDuration()) {
      // sound played in timer player
    } else if (this.currentClick === 0 && this.timerPlayerOutlet.hasAudio("start")) {
      this.timerPlayerOutlet.playAudio("start")
    } else if (this.isLastClickOfCycle() && !this.isLastCycle()) {
      this.timerPlayerOutlet.playAudio("metronomeChange")
    } else if (this.playClickValue) {
      this.timerPlayerOutlet.playAudio("click")
    }
  }

}
